import React from 'react'
import { Card } from '../../pages/Theme';
// import CrossGrayIcon from '../../common/images-new/cross-gray-icon.svg'
import ButtonBlue from '../Button/ButtonBlue'
import { staticFiles } from '../Helpers/Static'

const CROSS_GRAY_ICON = staticFiles.cross;

const ModalEditShowcase = ({handleClose, 
                                show, 
                                onChange, 
                                onClick, 
                                showcaseName, 
                                showcaseNameEmpty, 
                                showcaseNameExist,
                                showcaseLoader,
                                buttonDisabled,
                                selectedShowcase                            
                            }) => {
    const showHideModal = show
        ? 'fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 block modelIndex'
        : 'fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 hidden'
        
    const handleKeypress = e => {
        //it triggers by pressing the enter key
        if (e.key === 'Enter') {
            e.preventDefault()
            onClick()
        }
    };
        
    return(
        <div className={showHideModal} >
            <section className="fixed transform -translate-y-2/4 -translate-x-2/4 top-2/4 left-2/4">
                <Card className="h-60 w-80 md:w-full bg-white px-4 md:px-8 py-5 rounded-md filter drop-shadow-md">
                    <p className="text-center font-bold text-xl">Edit Showcase Name</p>
                    <img 
                        className="absolute right-4 md:right-8 top-6 cursor-pointer hover:opacity-60" 
                        onClick={handleClose} alt="cross" src={CROSS_GRAY_ICON}
                    />
                    <hr className='mt-3 border-gray-200'/>
                    <form className="flex flex-col mt-5 space-y-5">
                        <div className="flex flex-row py-2">
                            <label className="mr-2 md:mr-8 font-semibold md:py-3 md:whitespace-nowrap">
                                Showcase Name
                            </label>
                            <input 
                                className="bg-gray text-black pl-3 h-12 w-full md:w-96 rounded-lg border-2" 
                                type="text" 
                                placeholder={selectedShowcase}
                                value={showcaseName}
                                onChange={onChange}
                                onKeyPress={handleKeypress}
                            />
                        </div>
                    </form>
                    {showcaseNameEmpty === true &&
                    <span className="cover-file-show-error">Please enter the showcase name</span>
                    }
                    {showcaseNameExist === true &&
                    <span className="cover-file-show-error">Showcase name already exist</span>
                    }
                    <div className="absolute right-4 md:right-8 bottom-5">
                        {showcaseLoader 
                            ? <p className="font-semibold">Loading...</p>
                            : <ButtonBlue title="SAVE" onClick={onClick} disabled={buttonDisabled}/>
                        }
                    </div>
                    
                </Card>
            </section>
        </div>
    )
} 

export default ModalEditShowcase